module.exports = __webpack_public_path__ + "static/media/patch_panel_fiber.9a04f3c8.jpg";